export default __webpack_public_path__ + "static/media/ic-error.60fdc3c0.svg";